module.exports = __webpack_public_path__ + "img/15@2x.82929e34.png";